// ── LLS groups and centres ───────────────────────────────────────────────────
// LLS tours run for one of three groups of centres. Staff pick the group on
// the tour (requests.llsGroup: '1' | '2' | '3'), and every participant on the
// registration form picks the centre they belong to from that group's list.

export const LLS_GROUPS = ['1', '2', '3'];

export const LLS_CENTRES = {
  1: ['LLS Belfast', 'LLS Cliftonville', 'LLS Derry', 'LLS Dungannon', 'LLS Greysteel', 'LLS Jordanstown', 'LLS Larne FC',
    'LLS Larne High School', 'LLS Lurgan', 'LLS Omagh', 'LLS Cookstown'],
  2: ['LLS Liverpool', 'LLS Kirkby', 'LLS Alsager', 'LLS Market Drayton', 'LLS Brighouse', 'LLS Rugby', 'LLS Bradford Bulls'],
  3: ['LLS Flint', 'LLS Prestatyn', 'LLS Holyhead', 'LLS Croydon', 'LLS Greenwich', 'LLS Tower Hamlets', 'LLS Basketball'],
};

/** Group types compare case/space-insensitively ("lls " = "LLS"). */
export function isLlsGroupType(groupType) {
  return String(groupType || '').trim().toUpperCase() === 'LLS';
}

/** The centres participants can choose from for an LLS group, or []. */
export function llsCentresFor(group) {
  return LLS_CENTRES[String(group || '').trim()] || [];
}
